const ReviewSection = () => {
  return (
    <div className="mt-20 md:px-6 lg:px-40 ">
      <div className="flex ">
        <p className="border px-5 py-3 text-sm cursor-pointer bg-zinc-800 text-zinc-100 border-zinc-800 hover:bg-zinc-800 hover:text-zinc-100 transition2 ">
          Description
        </p>
        <p className="border px-5 py-3 text-sm cursor-pointer hover:bg-zinc-800 hover:text-zinc-100 transition2 border-zinc-800 ">
          Reviews (122)
        </p>
      </div>
      <div className="flex flex-col gap-4 border px-6 py-6  lg:p-10 text-sm text-gray-500">
        <p>
          An e-commerce website is lorem ipsum dolor sit amet consectetur
          adipisicing elit. Nostrum, aspernatur temporibus. Cupiditate illum,
          accusantium odit quibusdam sed exercitationem sapiente? Culpa adipisci
          molestiae ab accusantium incidunt, nam aspernatur illo saepe aut dicta
          provident debitis unde. Corporis praesentium debitis rem temporibus
          magnam.
        </p>
        <p>
          E-commerce lorem ipsum dolor sit, amet consectetur adipisicing elit.
          Dolorem quo enim quae eum rem voluptatum reiciendis sunt quibusdam
          corporis, qui itaque maxime nihil illo sit.
        </p>
      </div>
    </div>
  );
};

export default ReviewSection;
